<template>
  <modal
    name="confirmAgain"
    transition="nice-modal-fade"
    :pivotY="0.3"
    :width="420"
    :height="210"
    :classes="[]"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="container">
      <div class="content">
        <div>是否确认输出视频，输出后将扣除视频导出权益次数；</div>
        <div>若需要确认视频效果，请选择分享项目。</div>
      </div>
      <div class="footer">
        <div class="button button--primary" @click.stop="share($event)">分享项目</div>
        <div class="button button--primary" @click="confirm">继续发布视频</div>
      </div>
      <div class="close-btn" @click="hide()">
        <i class="icon-popup-close"></i>
      </div>

      <div class="control">
        <el-checkbox v-model="checked" @change="store">不再提示</el-checkbox>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      checked: false,
    }
  },
  watch: {

  },
  mounted () {

  },
  methods: {
    beforeOpen () {
      this.readStore();
    },
    closed () {
      this.$bus.emit('confirmAgain.closed');
    },
    hide () {
      this.$modal.hide('confirmAgain');
      this.$bus.off('confirmAgain.confirm');
    },
    confirm () {
      this.$bus.emit('confirmAgain.confirm');
      // this.$modal.hide('confirmAgain');
    },
    share (ev) {
      // this.$bus.off('confirmAgain.confirm');
      let el = ev.target;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('share.show', {
        left: rect.left,
        top: rect.bottom + 10,
      })
    },
    store (checked) {
      let confirmAgainChecked = checked;
      this.$util.localStorage.set('export.confirmAgainChecked', confirmAgainChecked);
      if (checked) {
        this.$message({
          type: 'success',
          message: '关闭确认提示后，导出视频将直接扣除视频导出权益',
        });
      }
    },
    readStore () {
      let confirmAgainChecked = this.$util.localStorage.get('export.confirmAgainChecked');
      this.checked = confirmAgainChecked;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
}

.content {
  margin-bottom: 24px;
  min-height: 44px;

  & > div:first-of-type {
    padding-bottom: 0.5em;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;

  >div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}

.control {
  position: absolute;
  bottom: 14px;
  right: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/topnav/exportDialog/confirmAgain.vue